module.exports = __webpack_public_path__ + "img/mindshift.bbb56420.jpg";